"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.ActionContextCreator = react_1.default.createContext({
    superApi(operation, options) { },
    superTableCategory: "",
    superTableSubCategory: "",
    table: null,
    actionDispatcher: () => { },
    cellResizer: (e) => { },
    searchApi: async (searchKey, searchValue) => [],
});
//# sourceMappingURL=actionContext.js.map